import { useEffect, useState } from "react"
import { Alert, Button, Col, Modal, Row, Spinner } from "react-bootstrap"
import { Link, Navigate, useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../stores/hooks"
import { getAchievementListAsync, AchievementState } from "../AchievementSlice"
import { deleteAchievement } from "../AchievementAPI"
import BootstrapTable from "react-bootstrap-table-next"
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"
// import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import paginationFactory from "react-bootstrap-table2-paginator"
import Config from "../../../utils/config"
import { useAlert } from "react-alert"

/**
 * Achievementing list page
 */
const AchievementList = () => {
  const { achievements, status, totalRecord } = useAppSelector(AchievementState)
  const [page, setPage] = useState(1)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { SearchBar, ClearSearchButton } = Search
  const [sort, setSort] = useState("updated_at")
  const [order, setOrder] = useState("DESC")
  const [deleteItem, setDeleteItem] = useState("")
  const [searchText, setSearchText] = useState("")
  const alert = useAlert()

  useEffect(() => {
    getPageData()
  }, [dispatch, page, sort, order])

  const getPageData = () => {
    const filter = {
      page: page,
      sortField: sort,
      order: order,
    }
    dispatch(getAchievementListAsync(filter))
  }

  const removeAchievement = async () => {
    const res: any = await deleteAchievement(deleteItem)
    if (
      res?.statusCode != 200 &&
      res?.statusCode != 201 &&
      res.data == undefined
    ) {
      alert.error(res.message)
    } else {
      alert.success("Data deleted Successfully")
    }
    setDeleteItem("")
    getPageData()
  }

  const customTotal = (from: any, to: any, size: any) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  )

  const options = {
    sizePerPage: 10,
    paginationSize: 5,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: false, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: totalRecord,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  }

  const columns = [
    {
      dataField: "event_title",
      text: "Event Title",
      sort: true,
      formatter: (cellContent: any, row: any) =>
        row?.event_image ? (
          <div className="row">
            <span className="col-md-5 col-xl-auto">
              <img
                className="rounded-circle rounded-circle-border"
                height="50"
                width="50"
                src={`${Config.cdnUrl}${row?.event_image}`}
              />{" "}
            </span>
            <div className="col-md-7"> {row.event_title} </div>
          </div>
        ) : (
          <>
            <span className="up mr-10">{row.event_title}</span>
            <span> {row.event_title}</span>
          </>
        ),
    },
    {
      dataField: "event_description",
      text: "Event Description",
      sort: true,
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
    },
    {
      dataField: "contest_id",
      text: "Contest / Shopping Amount",
      headerAlign: "center",
      align: "center",
      classes: "col-2",
      sort: true,
      formatter: (cell: any, row: any) => {
        if (row.contest_id) {
          if (row.credit) {
            return `${row.Contest.title.en} - ${row.credit}`
          } else {
            return row.Contest.title.en
          }
        } else {
          return row.shopping_amount || row.credit
        }
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      classes: "col-1",
      formatter: (cellContent: any, row: any) => (
        <div className="d-flex justify-content-around">
          <i
            className="feather icon-trash-2 text-danger fw-bold"
            onClick={() => {
              setDeleteItem(row.achievement_id)
            }}
          ></i>
          <i
            className="feather icon-edit text-success fw-bold"
            onClick={() => {
              navigate(`/achievement/update/${row.achievement_id}`)
            }}
          ></i>
          <i
            className="feather icon-eye text-success fw-bold"
            onClick={() => {
              navigate(`/achievement/details/${row.achievement_id}`)
            }}
          ></i>
        </div>
      ),
    },
  ]

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
  }

  const listData = achievements.filter((e: any) => {
    return (
      e?.event_title.toUpperCase().indexOf(searchText.toUpperCase()) >= 0 ||
      e?.event_description.toString().indexOf(searchText.toString()) >= 0 ||
      e?.credit?.toString().indexOf(searchText.toString()) >= 0 ||
      e?.shopping_amount?.toString().indexOf(searchText.toString()) >= 0 ||
      e?.type.toUpperCase().indexOf(searchText.toUpperCase()) >= 0 ||
      e?.Contest?.title?.en?.indexOf(searchText.toString()) >= 0
    )
  })

  return (
    <>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="page-header-title">
                <h5 className="m-b-10">Achievement</h5>
              </div>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="feather icon-home"></i>
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <a>Achievements</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="main-body">
        <div className="page-wrapper">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <Row>
                    <Col auto>
                      <h5>Achievements</h5>
                    </Col>
                    <Col md={2}>
                      <Link
                        className="btn btn-primary"
                        to="/achievement/create"
                      >
                        Add Achievement
                      </Link>
                    </Col>
                  </Row>
                </div>
                <div className="card-block table-border-style">
                  {status === "loading" ? (
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : status === "failed" ? (
                    <Alert key={"danger"} variant={"danger"}>
                      Something went wrong please try again
                    </Alert>
                  ) : (
                    <>
                      <ToolkitProvider
                        keyField="id"
                        data={listData}
                        columns={columns}
                        selectRow={selectRow}
                        search
                        exportCSV
                      >
                        {(props: any) => (
                          <Row>
                            <Col>
                              <input
                                placeholder="Search"
                                type={"text"}
                                value={searchText}
                                className="form-control"
                                onChange={(e) => {
                                  setSearchText(e.target.value)
                                }}
                              />
                            </Col>
                            <Col>
                              <div>
                                {/* <SearchBar {...props.searchProps} /> */}
                                <ClearSearchButton
                                  {...props.searchProps}
                                  className="btn-primary fw-bold ms-2"
                                />
                                {/* <ExportCSVButton
                                {...props.csvProps}
                                className="btn-success fw-bold ms-2"
                              >
                                Export CSV
                              </ExportCSVButton> */}
                              </div>
                            </Col>
                            <BootstrapTable
                              filter={filterFactory()}
                              pagination={paginationFactory(options)}
                              {...props.baseProps}
                            />
                          </Row>
                        )}
                      </ToolkitProvider>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {deleteItem ? (
        <Modal show={true} onHide={() => setDeleteItem("")}>
          <Modal.Header closeButton>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete Achievement?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setDeleteItem("")}>
              Close
            </Button>
            <Button
              className="btn-danger"
              variant="primary"
              onClick={removeAchievement}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      ) : null}
    </>
  )
}
export default AchievementList
